import type { GenerateRequest, SseEvent } from '@hysys-uv/shared';

const API_BASE = (import.meta.env.VITE_API_BASE ?? '').replace(/\/$/, '');

export async function* streamGenerate(
  request: GenerateRequest,
  signal?: AbortSignal,
): AsyncGenerator<SseEvent, void, void> {
  const resp = await fetch(`${API_BASE}/api/generate`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(request),
    signal,
  });

  if (!resp.ok) {
    const text = await resp.text().catch(() => '');
    throw new Error(`API ${resp.status}: ${text || resp.statusText}`);
  }
  if (!resp.body) throw new Error('No response body');

  const reader = resp.body.getReader();
  const decoder = new TextDecoder();
  let buffer = '';

  while (true) {
    const { value, done } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    let idx: number;
    while ((idx = buffer.indexOf('\n\n')) !== -1) {
      const raw = buffer.slice(0, idx).trim();
      buffer = buffer.slice(idx + 2);
      if (!raw.startsWith('data:')) continue;
      const payload = raw.slice('data:'.length).trim();
      if (!payload) continue;
      try {
        yield JSON.parse(payload) as SseEvent;
      } catch {
        // ignore malformed frames
      }
    }
  }
}
